/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class SearchBarStyle extends Fragment {
  @attr('string') declare width: string;
  @attr('number') declare borderRadius: number;
}
